// extracted by css-extract-rspack-plugin
export default {"list":"list-GND0DR","pill":"pill-D8Fiin","active":"active-pmJ4Ve"};